module.exports = "<div class=\"widget-wrapper wow fadeIn\" data-wow-delay=\"0.2s\">\n  <br>\n  <div class=\"list-group\">\n    <a class=\"list-group-item\" [routerLink]=\"['/dich-vu/tq']\">Vận chuyển hàng từ TQ về VN</a>\n    <a class=\"list-group-item\" [routerLink]=\"['/dich-vu/mua']\">Mua hàng hộ từ TQ về VN</a>\n    <a class=\"list-group-item\" [routerLink]=\"['/dich-vu/thanh-toan']\">Thanh toán hộ Alipay</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shipping-services/menu/menu.component.html
// module id = 925
// module chunks = 3